module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticStyle: {
      "height": "100vh",
      "width": "100vw",
      "background-color": "#fafafa",
      "flex": "auto",
      "-webkit-flex": "auto",
      "position": "fixed"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "position": "-webkit-sticky"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('div', {
    staticClass: "flex-y-bottom"
  }, [_c('div', {
    staticClass: "bo-logo flex-grow-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.serviceUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bo-title flex-grow-1"
  }, [_c('div', [_vm._v(_vm._s(_vm.information.boSolution.children[0].externalName ? _vm.information.boSolution.children[0].externalName : _vm.information.boSolution.children[0].name))]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.information.boSolution.children[0].briefInfoDetail) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_c('span', {
    staticClass: "real-price"
  }, [_vm._v("￥" + _vm._s(_vm.emkt.formatPrice(_vm.information.boSolution.children[0].formalQuotePrice)))]), _vm._v(" "), _c('span', {
    staticClass: "sale-price"
  }, [_c('s', [_vm._v("￥" + _vm._s(_vm.emkt.formatPrice(_vm.information.boSolution.children[0].standardPrice)))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 right"
  }, [_c('span', {
    staticClass: "deliver-text"
  }, [_vm._v("预计交付周期：")]), _vm._v(" "), _c('span', {
    staticClass: "deliver-value"
  }, [_vm._v(_vm._s(_vm.information.boSolution.children[0].workdays) + "个工作日")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "80vh",
      "overflow": "auto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("样本信息")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [_c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本物种")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.sampleSpec) + " " + _vm._s(_vm.information.otherTaxName))])], 1)], 1), _vm._v(" "), _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("疾病方向")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.diseaseDirection.name))])], 1)], 1), _vm._v(" "), (_vm.information.currEu !== _vm.specialEuTemplateNo(0)) ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本分类")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.singleMeteData.sampleCategory.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本类型")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.sampleType))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("实验分组及样本数")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [_vm._l((_vm.information.boSolution.children[0].groups), function(experimental, index) {
    return _c('van-cell', {
      key: experimental.name
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v(_vm._s(experimental.name))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(experimental.bioRepeatTimes))])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.information.controlGroups), function(it, index) {
    return _c('van-cell', {
      key: index
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v("生信分析组" + _vm._s(index + 1))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(it[0]) + " VS " + _vm._s(it[1]))])], 1)], 1)
  })], 2)]), _vm._v(" "), (_vm.information.currEu !== _vm.specialEuTemplateNo(0)) ? _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("其他参数")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [(_vm.information.singleMeteData.paraRemoveHAProtein.dictValue !== '-') ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本处理")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.singleMeteData.paraRemoveHAProtein.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.information.singleMeteData.paraConstructionTech.dictValue !== '-') ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("建库技术")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.singleMeteData.paraConstructionTech.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.information.singleMeteData.paraBioAnalysis.dictValue !== '-') ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("生信分析")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.singleMeteData.paraBioAnalysis.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.information.geneSelectionGroup.length > 0) ? _c('div', _vm._l((_vm.information.geneSelectionGroup), function(item, index) {
    return _c('van-cell', {
      key: index
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v("基因" + _vm._s(index + 1))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(item.outlineInfo))])], 1)], 1)
  }), 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("质量承诺")]), _vm._v(" "), _vm._l((_vm.serviceWorkDaysSolution.qualityCommitment), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cell-group-wrap",
      staticStyle: {
        "font-size": "12px",
        "padding": "0 20px"
      }
    }, [_c('div', [_vm._v(_vm._s(index + 1) + "、" + _vm._s(item.nameList[0]))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("服务说明")]), _vm._v(" "), _vm._l((_vm.serviceWorkDaysSolution.serviceComments), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cell-group-wrap",
      staticStyle: {
        "font-size": "12px",
        "padding": "0 20px"
      }
    }, [_c('div', [_vm._v(_vm._s(index + 1) + "、" + _vm._s(item.nameList[0]))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  })], 2)]), _vm._v(" "), _vm._m(0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#D2D2D6",
      "text-align": "center",
      "pointer-events": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "50%"
    }
  }, [_vm._v("---我是有底线的---")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0042c16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/BoSolution/BoSolutionDetail.vue
// module id = 1715
// module chunks = 8